import { getAppConfig } from '@web/src/lib/env.dynamic.client'
import { adminClient, inferAdditionalFields } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import type { auth } from './auth'

export const authClient = createAuthClient({
  baseURL: getAppConfig().APP_URL,
  plugins: [inferAdditionalFields<typeof auth>(), adminClient()],
})
